// 教育局二级域名定制网页配置参数
import {
    RadioGroup
} from "element-ui";
import LYCom from "../../../static/js/LYCom";

const eduWebConfig = {
    namespaced: true,
    state: {
        eduWebConfigInfo: null, // 当前教育局信息
        studentInfoDialog: false, //是否显示学生信息展示弹框
        //不显示学生身份证号栏
        noShowIdcardEduList: [{
            name: '甘洛县教育体育和科学技术局',
            id: 4795599
        }],
        eudList: [{
                eduName: '心海蓝韵',
                webName: '心理健康教育平台',
                teacherShowReport: true, // 是否向老师展示报告
                menus: [], // 自定义配置菜单栏
                studentMenus: [], // 自定义学生pc端菜单栏
                scaleAlias: false, // 量表显示别名  （屏蔽"心理"字段）
                realmName: 'https://lanyunxinli.cn' // 域名地址
            },
            {
                eduName: '心海蓝韵',
                webName: '心理健康教育平台',
                teacherShowReport: true, // 是否向老师展示报告
                menus: [], // 自定义配置菜单栏
                studentMenus: [], // 自定义学生pc端菜单栏
                scaleAlias: false, // 量表显示别名  （屏蔽"心理"字段）
                realmName: 'https://www.lanyunxinli.cn' // 域名地址
            }, {
                eudid: 1, // 教育局编号
                eduName: '康定市教育和体育局', // 教育局名称
                webName: '青少年健康成长辅导平台', // 平台名称
                teacherShowReport: false, // 是否向老师展示报告
                menus: [{
                        "AuthorityOperationList": [],
                        "children": [],
                        "menu_id": 220011,
                        "name": "home",
                        "displayName": "首页",
                        "parent_id": 0,
                        "url": "/schoolHome",
                        "sort": 0,
                        "icon": "el-icon-s-home",
                        "visible": 1,
                        "necessary": 1,
                        "permission": null,
                        "remark": null,
                        "is_school": 0,
                        "Authority": 1,
                        "OperationList": null
                    },
                    {
                        "AuthorityOperationList": [],
                        "children": [{
                            "AuthorityOperationList": [],
                            "children": [],
                            "menu_id": 84024,
                            "name": "teacher",
                            "displayName": "教师管理",
                            "parent_id": 58011,
                            "url": "/schoolmgr/teacher",
                            "sort": 1,
                            "icon": "el-icon-user-solid",
                            "visible": 1,
                            "necessary": 1,
                            "permission": null,
                            "remark": null,
                            "is_school": 0,
                            "Authority": 1,
                            "OperationList": null
                        }, {
                            "AuthorityOperationList": [],
                            "children": [],
                            "menu_id": 84022,
                            "name": "grade",
                            "displayName": "年级管理",
                            "parent_id": 58011,
                            "url": "/schoolmgr/grade",
                            "sort": 2,
                            "icon": "el-icon-s-grid",
                            "visible": 1,
                            "necessary": 1,
                            "permission": null,
                            "remark": null,
                            "is_school": 1,
                            "Authority": 1,
                            "OperationList": null
                        }, {
                            "AuthorityOperationList": [],
                            "children": [],
                            "menu_id": 3033292,
                            "name": "major",
                            "displayName": "专业管理",
                            "parent_id": 58011,
                            "url": "/schoolmgr/major",
                            "sort": 3,
                            "icon": "el-icon-collection",
                            "visible": 1,
                            "necessary": 0,
                            "permission": "1#查看,2#添加,3#修改,4#删除",
                            "remark": null,
                            "is_school": 0,
                            "Authority": 1,
                            "OperationList": [{
                                "Name": "查看",
                                "Type": 1,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "添加",
                                "Type": 2,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "修改",
                                "Type": 3,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "删除",
                                "Type": 4,
                                "Code": null,
                                "Authority": 0
                            }]
                        }, {
                            "AuthorityOperationList": [],
                            "children": [],
                            "menu_id": 84023,
                            "name": "class",
                            "displayName": "班级管理",
                            "parent_id": 58011,
                            "url": "/schoolmgr/class",
                            "sort": 4,
                            "icon": "el-icon-house",
                            "visible": 1,
                            "necessary": 1,
                            "permission": "1#查看",
                            "remark": null,
                            "is_school": 1,
                            "Authority": 1,
                            "OperationList": [{
                                "Name": "查看",
                                "Type": 1,
                                "Code": null,
                                "Authority": 0
                            }]
                        }, {
                            "AuthorityOperationList": [],
                            "children": [],
                            "menu_id": 84025,
                            "name": "student",
                            "displayName": "学生管理",
                            "parent_id": 58011,
                            "url": "/schoolmgr/student",
                            "sort": 5,
                            "icon": "el-icon-s-check",
                            "visible": 1,
                            "necessary": 1,
                            "permission": "1#查看,2#添加,3#修改,4#删除",
                            "remark": null,
                            "is_school": 0,
                            "Authority": 1,
                            "OperationList": [{
                                "Name": "查看",
                                "Type": 1,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "添加",
                                "Type": 2,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "修改",
                                "Type": 3,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "删除",
                                "Type": 4,
                                "Code": null,
                                "Authority": 0
                            }]
                        }, {
                            "AuthorityOperationList": [],
                            "children": [],
                            "menu_id": 358068,
                            "name": "archives",
                            "displayName": "档案管理",
                            "parent_id": 58011,
                            "url": "/sysmgr/archives",
                            "sort": 6,
                            "icon": "el-icon-wallet",
                            "visible": 1,
                            "necessary": 0,
                            "permission": null,
                            "remark": null,
                            "is_school": 0,
                            "Authority": 1,
                            "OperationList": null
                        }, {
                            "AuthorityOperationList": [],
                            "children": [],
                            "menu_id": 3510761,
                            "name": "studentDetail",
                            "displayName": "学生详情",
                            "parent_id": 58011,
                            "url": "/schoolmgr/studentDetail",
                            "sort": 8,
                            "icon": "el-icon-s-order",
                            "visible": 0,
                            "necessary": 0,
                            "permission": "1#查看,2#添加,3#修改,4#删除",
                            "remark": null,
                            "is_school": 0,
                            "Authority": 1,
                            "OperationList": [{
                                "Name": "查看",
                                "Type": 1,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "添加",
                                "Type": 2,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "修改",
                                "Type": 3,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "删除",
                                "Type": 4,
                                "Code": null,
                                "Authority": 0
                            }]
                        }],
                        "menu_id": 58011,
                        "name": "schoolmgr",
                        "displayName": "学校管理",
                        "parent_id": 0,
                        "url": "/schoolmgr/",
                        "sort": 4,
                        "icon": "el-icon-school",
                        "visible": 1,
                        "necessary": 1,
                        "permission": null,
                        "remark": null,
                        "is_school": 0,
                        "Authority": 1,
                        "OperationList": null
                    },
                    {
                        "AuthorityOperationList": [],
                        "children": [{
                            "AuthorityOperationList": [],
                            "children": [],
                            "menu_id": 250032,
                            "name": "psychologyTask",
                            "displayName": "任务管理",
                            "parent_id": 96011,
                            "url": "/task/psychologyTask",
                            "sort": 1,
                            "icon": "el-icon-s-marketing",
                            "visible": 1,
                            "necessary": 1,
                            "permission": "1#查看,2#添加,3#修改,4#删除,7#取消关注,8#重测",
                            "remark": null,
                            "is_school": 0,
                            "Authority": 1,
                            "OperationList": [{
                                "Name": "查看",
                                "Type": 1,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "添加",
                                "Type": 2,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "修改",
                                "Type": 3,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "删除",
                                "Type": 4,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "取消关注",
                                "Type": 7,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "重测",
                                "Type": 8,
                                "Code": null,
                                "Authority": 0
                            }]
                        }, {
                            "AuthorityOperationList": [],
                            "children": [],
                            "menu_id": 128082,
                            "name": "historyTask",
                            "displayName": "历史任务",
                            "parent_id": 96011,
                            "url": "/task/historyTask",
                            "sort": 2,
                            "icon": "el-icon-s-order",
                            "visible": 1,
                            "necessary": 1,
                            "permission": "1#查看,7#取消关注,8#重测",
                            "remark": null,
                            "is_school": 0,
                            "Authority": 1,
                            "OperationList": [{
                                "Name": "查看",
                                "Type": 1,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "取消关注",
                                "Type": 7,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "重测",
                                "Type": 8,
                                "Code": null,
                                "Authority": 0
                            }]
                        }],
                        "menu_id": 96011,
                        "name": "task",
                        "displayName": "任务管理",
                        "parent_id": 0,
                        "url": "/task/",
                        "sort": 5,
                        "icon": "el-icon-s-order",
                        "visible": 1,
                        "necessary": 1,
                        "permission": null,
                        "remark": null,
                        "is_school": 0,
                        "Authority": 1,
                        "OperationList": null
                    },
                    {
                        "AuthorityOperationList": [],
                        "children": [{
                            "AuthorityOperationList": [],
                            "children": [],
                            "menu_id": 219120,
                            "name": "classmgr",
                            "displayName": "课程管理",
                            "parent_id": 155070,
                            "url": "/psychology/classmgr",
                            "sort": 0,
                            "icon": "el-icon-menu",
                            "visible": 1,
                            "necessary": 1,
                            "permission": "1#查看,2#添加,3#修改",
                            "remark": null,
                            "is_school": 0,
                            "Authority": 1,
                            "OperationList": [{
                                "Name": "查看",
                                "Type": 1,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "添加",
                                "Type": 2,
                                "Code": null,
                                "Authority": 0
                            }, {
                                "Name": "修改",
                                "Type": 3,
                                "Code": null,
                                "Authority": 0
                            }]
                        }],
                        "menu_id": 155070,
                        "name": "psychology",
                        "displayName": "健康成长课程",
                        "parent_id": 0,
                        "url": "/psychology/",
                        "sort": 8,
                        "icon": "el-icon-s-opportunity",
                        "visible": 1,
                        "necessary": 0,
                        "permission": null,
                        "remark": null,
                        "is_school": 0,
                        "Authority": 1,
                        "OperationList": null
                    },
                    {
                        "AuthorityOperationList": [],
                        "children": [{
                            "AuthorityOperationList": [],
                            "children": [],
                            "menu_id": 163111,
                            "name": "trainquery",
                            "displayName": "训练管理",
                            "parent_id": 163110,
                            "url": "/psychologyTrain/trainquery",
                            "sort": 0,
                            "icon": "el-icon-search",
                            "visible": 1,
                            "necessary": 1,
                            "permission": "1#查看",
                            "remark": null,
                            "is_school": 0,
                            "Authority": 1,
                            "OperationList": [{
                                "Name": "查看",
                                "Type": 1,
                                "Code": null,
                                "Authority": 0
                            }]
                        }, {
                            "AuthorityOperationList": [],
                            "children": [],
                            "menu_id": 194026,
                            "name": "videoPlayer",
                            "displayName": "视频播放",
                            "parent_id": 163110,
                            "url": "/psychologyTrain/videoPlayer",
                            "sort": 1,
                            "icon": "el-icon-search",
                            "visible": 0,
                            "necessary": 1,
                            "permission": null,
                            "remark": null,
                            "is_school": 1,
                            "Authority": 1,
                            "OperationList": null
                        }],
                        "menu_id": 163110,
                        "name": "psychologyTrain",
                        "displayName": "健康成长训练",
                        "parent_id": 0,
                        "url": "/psychologyTrain/",
                        "sort": 9,
                        "icon": "fa fa-heartbeat",
                        "visible": 1,
                        "necessary": 0,
                        "permission": null,
                        "remark": null,
                        "is_school": 0,
                        "Authority": 1,
                        "OperationList": null
                    },
                    {
                        "AuthorityOperationList": [],
                        "children": [{
                            "AuthorityOperationList": [],
                            "children": [{
                                "AuthorityOperationList": [],
                                "children": [],
                                "menu_id": 1112004,
                                "name": "teacherTaskList",
                                "displayName": "任务管理",
                                "parent_id": 1112003,
                                "url": "/task/teacherTask",
                                "sort": 1,
                                "icon": "el-icon-s-order",
                                "visible": 1,
                                "necessary": 0,
                                "permission": null,
                                "remark": null,
                                "is_school": 0,
                                "Authority": 1,
                                "OperationList": null
                            }, {
                                "AuthorityOperationList": [],
                                "children": [],
                                "menu_id": 1112005,
                                "name": "teacherHistoryTask",
                                "displayName": "历史任务",
                                "parent_id": 1112003,
                                "url": "/task/teacherHistoryTask",
                                "sort": 2,
                                "icon": "el-icon-s-claim",
                                "visible": 1,
                                "necessary": 0,
                                "permission": null,
                                "remark": null,
                                "is_school": 0,
                                "Authority": 1,
                                "OperationList": null
                            }, {
                                "AuthorityOperationList": [],
                                "children": [],
                                "menu_id": 1112006,
                                "name": "addTeacherEvaluateTask",
                                "displayName": "添加任务",
                                "parent_id": 1112003,
                                "url": "/task/addTeacherTask",
                                "sort": 2,
                                "icon": "el-icon-circle-plus-outline",
                                "visible": 0,
                                "necessary": 0,
                                "permission": null,
                                "remark": null,
                                "is_school": 0,
                                "Authority": 1,
                                "OperationList": null
                            }],
                            "menu_id": 1112003,
                            "name": "teacherTask",
                            "displayName": "任务管理",
                            "parent_id": 1112002,
                            "url": "/teacherTask",
                            "sort": 1,
                            "icon": "el-icon-s-order",
                            "visible": 1,
                            "necessary": 0,
                            "permission": null,
                            "remark": null,
                            "is_school": 0,
                            "Authority": 1,
                            "OperationList": null
                        }],
                        "menu_id": 1112002,
                        "name": "teacherMental",
                        "displayName": "教师筛查任务",
                        "parent_id": 0,
                        "url": "/teacherMental",
                        "sort": 12,
                        "icon": "el-icon-s-custom",
                        "visible": 1,
                        "necessary": 0,
                        "permission": null,
                        "remark": null,
                        "is_school": 0,
                        "Authority": 1,
                        "OperationList": null
                    },

                ], // 自定义系统配置菜单栏
                studentMenus: [{
                    "AuthorityOperationList": [],
                    "children": [{
                        "AuthorityOperationList": [],
                        "children": [],
                        "menu_id": 146013,
                        "name": "myTask",
                        "displayName": "我的任务",
                        "parent_id": 96011,
                        "url": "/sysmgr/myTask",
                        "sort": 6,
                        "icon": "el-icon-reading",
                        "visible": 1,
                        "necessary": 1,

                        "remark": null,
                        "is_school": 0,
                        "Authority": 1,

                    }],
                    "menu_id": 96011,
                    "name": "task",
                    "displayName": "任务管理",
                    "parent_id": 0,
                    "url": "/task/",
                    "sort": 5,
                    "icon": "el-icon-s-order",
                    "visible": 1,
                    "necessary": 1,
                    "permission": null,
                    "remark": null,
                    "is_school": 0,
                    "Authority": 1,
                    "OperationList": null
                }, {
                    "AuthorityOperationList": [],
                    "children": [{
                        "AuthorityOperationList": [],
                        "children": [],
                        "menu_id": 249017,
                        "name": "myEvaluation",
                        "displayName": "我的问卷",
                        "parent_id": 249016,
                        "url": "/psychologyEvaluation/myEvaluation",
                        "sort": 1,
                        "icon": "el-icon-s-order",
                        "visible": 1,
                        "necessary": 1,
                        "permission": null,
                        "remark": null,
                        "is_school": 0,
                        "Authority": 1,
                        "OperationList": null
                    }, {
                        "AuthorityOperationList": [],
                        "children": [],
                        "menu_id": 306534,
                        "name": "answer",
                        "displayName": "答题",
                        "parent_id": 249016,
                        "url": "/psychoEvaluation/answer",
                        "sort": 7,
                        "icon": "",
                        "visible": 0,
                        "necessary": 0,
                        "permission": null,
                        "remark": null,
                        "is_school": 1,
                        "Authority": 1,
                        "OperationList": null
                    }],
                    "menu_id": 249016,
                    "name": "evaluation",
                    "displayName": "健康成长问卷",
                    "parent_id": 0,
                    "url": "/psychologyEvaluation/",
                    "sort": 6,
                    "icon": "el-icon-s-order",
                    "visible": 1,
                    "necessary": 1,
                    "permission": null,
                    "remark": null,
                    "is_school": 0,
                    "Authority": 1,
                    "OperationList": null
                }, {
                    "AuthorityOperationList": [],
                    "children": [{
                        "AuthorityOperationList": [],
                        "children": [],
                        "menu_id": 219142,
                        "name": "mystudy",
                        "displayName": "我的学习",
                        "parent_id": 155070,
                        "url": "/psychology/mystudy",
                        "sort": 1,
                        "icon": "el-icon-document",
                        "visible": 1,
                        "necessary": 1,
                        "permission": "1#查看,2#添加,3#修改,4#删除",
                        "remark": null,
                        "is_school": 0,
                        "Authority": 1,
                    }],
                    "menu_id": 155070,
                    "name": "psychology",
                    "displayName": "健康成长课程",
                    "parent_id": 0,
                    "url": "/psychology/",
                    "sort": 8,
                    "icon": "el-icon-s-opportunity",
                    "visible": 1,
                    "necessary": 0,
                    "permission": "1#查看,2#添加,3#修改,4#删除",
                    "remark": null,
                    "is_school": 0,
                    "Authority": 1,

                }, {
                    "AuthorityOperationList": [],
                    "children": [{
                        "AuthorityOperationList": [],
                        "children": [],
                        "menu_id": 248012,
                        "name": "myTrain",
                        "displayName": "我的训练",
                        "parent_id": 163110,
                        "url": "/psychologyTrain/myTrain",
                        "sort": 3,
                        "icon": "el-icon-connection",
                        "visible": 1,
                        "necessary": 1,
                        "permission": null,
                        "remark": null,
                        "is_school": 0,
                        "Authority": 1,
                        "OperationList": null
                    }],
                    "menu_id": 163110,
                    "name": "psychologyTrain",
                    "displayName": "健康成长训练",
                    "parent_id": 0,
                    "url": "/psychologyTrain/",
                    "sort": 9,
                    "icon": "fa fa-heartbeat",
                    "visible": 1,
                    "necessary": 0,
                    "permission": null,
                    "remark": null,
                    "is_school": 0,
                    "Authority": 1,
                    "OperationList": null
                }], // 自定义学生pc端菜单栏
                scaleAlias: true, // 量表显示别名  （屏蔽"心理"字段）
                realmName: 'https://kdjy.lanyunxinli.cn' // 域名地址
            },
            {
                eudid: 2, // 教育局编号
                eduName: '大英县教育局', // 教育局名称
                webName: '心理健康教育平台', // 平台名称
                teacherShowReport: true, // 是否向老师展示报告
                menus: [], // 自定义配置菜单栏
                studentMenus: [], // 自定义学生pc端菜单栏
                scaleAlias: false, // 量表显示别名  （屏蔽"心理"字段）
                realmName: 'https://dyjy.lanyunxinli.cn' // 域名地址
            },
            {
                eudid: 3, // 教育局编号
                eduName: '汶川县教育局', // 教育局名称
                webName: '心理健康教育平台', // 平台名称
                teacherShowReport: true, // 是否向老师展示报告
                menus: [], // 自定义配置菜单栏
                studentMenus: [], // 自定义学生pc端菜单栏
                scaleAlias: false, // 量表显示别名  （屏蔽"心理"字段）
                realmName: 'https://wcjy.lanyunxinli.cn' // 域名地址
            },
            {
                eudid: 4, // 教育局编号
                eduName: '黑水县教育局', // 教育局名称
                webName: '心理健康教育平台', // 平台名称
                teacherShowReport: true, // 是否向老师展示报告
                menus: [], // 自定义配置菜单栏
                studentMenus: [], // 自定义学生pc端菜单栏
                scaleAlias: false, // 量表显示别名  （屏蔽"心理"字段）
                realmName: 'https://hsjy.lanyunxinli.cn' // 域名地址
            },
            {
                eudid: 5, // 教育局编号
                eduName: '西宁市中庄小学', // 教育局名称
                webName: '心理健康教育平台', // 平台名称
                teacherShowReport: true, // 是否向老师展示报告
                menus: [], // 自定义配置菜单栏
                staticMenus: [{
                    Authority: 1,
                    AuthorityOperationList: [],
                    children: [],
                    OperationList: [],
                    displayName: "心理健康调查问卷",
                    icon: "el-icon-s-claim",
                    is_school: 0,
                    menu_id: 1939072,
                    name: "Qhquestionnaire",
                    necessary: 0,
                    parent_id: 0,
                    permission: "1#查看",
                    remark: null,
                    sort: 59,
                    url: "/Qhquestionnaire",
                    visible: 1,
                }], // 新增静态菜单栏
                studentMenus: [], // 自定义学生pc端菜单栏
                scaleAlias: false, // 量表显示别名  （屏蔽"心理"字段）
                realmName: 'https://xnjy.lanyunxinli.cn', // 域名地址
                isQingHai: true, // 显示青海伟一集团信息
                isQuestionnaire: true, // 是否显示调查问卷
            }, {
                eudid: 6, // 教育局编号
                eduName: '邻水县教育科技和体育局', // 教育局名称
                webName: '心理健康教育平台', // 平台名称
                teacherShowReport: true, // 是否向老师展示报告
                menus: [], // 自定义配置菜单栏
                studentMenus: [], // 自定义学生pc端菜单栏
                scaleAlias: false, // 量表显示别名  （屏蔽"心理"字段）
                realmName: 'https://lsjy.lanyunxinli.cn' // 域名地址
            },
            {
                eudid: 7, // 教育局编号
                eduName: '荥经县教育局', // 教育局名称
                webName: '心理健康教育平台', // 平台名称
                teacherShowReport: true, // 是否向老师展示报告
                menus: [], // 自定义配置菜单栏
                studentMenus: [], // 自定义学生pc端菜单栏
                scaleAlias: false, // 量表显示别名  （屏蔽"心理"字段）
                realmName: 'https://yjjy.lanyunxinli.cn' // 域名地址
            },
            {
                eudid: 8, // 教育局编号
                eduName: '青海省中小学师生心理健康应用系统', // 教育局名称
                webName: '青海省中小学师生心理健康应用系统', // 平台名称
                teacherShowReport: true, // 是否向老师展示报告
                menus: [], // 自定义配置菜单栏
                studentMenus: [], // 自定义学生pc端菜单栏
                scaleAlias: false, // 量表显示别名  （屏蔽"心理"字段）
                realmName: 'https://qhjy.lanyunxinli.cn' // 域名地址
            },
            {
                eudid: 9, // 教育局编号
                eduName: '合川区教育局', // 教育局名称
                webName: '心理健康教育平台', // 平台名称
                teacherShowReport: true, // 是否向老师展示报告
                menus: [], // 自定义配置菜单栏
                studentMenus: [], // 自定义学生pc端菜单栏
                scaleAlias: false, // 量表显示别名  （屏蔽"心理"字段）
                realmName: 'https://hcjy.lanyunxinli.cn' // 域名地址
            },
            {
                eudid: 10, // 教育局编号
                eduName: '华蓥市教育和体育局', // 教育局名称
                webName: '心理健康教育平台', // 平台名称
                teacherShowReport: true, // 是否向老师展示报告
                menus: [], // 自定义配置菜单栏
                studentMenus: [], // 自定义学生pc端菜单栏
                scaleAlias: false, // 量表显示别名  （屏蔽"心理"字段）
                realmName: 'https://hyjy.lanyunxinli.cn' // 域名地址
            },
            {
                eudid: 11, // 教育局编号
                eduName: '铜梁区教育委员会', // 教育局名称
                webName: '心理健康教育平台', // 平台名称
                teacherShowReport: true, // 是否向老师展示报告
                menus: [], // 自定义配置菜单栏
                studentMenus: [], // 自定义学生pc端菜单栏
                scaleAlias: false, // 量表显示别名  （屏蔽"心理"字段）
                realmName: 'https://tljy.lanyunxinli.cn' // 域名地址
            },
            {
                eudid: 12, // 教育局编号
                eduName: '松潘县教育局', // 教育局名称
                webName: '心理健康教育平台', // 平台名称
                teacherShowReport: true, // 是否向老师展示报告
                menus: [], // 自定义配置菜单栏
                studentMenus: [], // 自定义学生pc端菜单栏
                scaleAlias: false, // 量表显示别名  （屏蔽"心理"字段）
                realmName: 'https://spjy.lanyunxinli.cn' // 域名地址
            },
            {
                eudid: 13, // 教育局编号
                eduName: '甘洛县教育体育和科学技术局', // 教育局名称
                webName: '心理健康教育平台', // 平台名称
                teacherShowReport: true, // 是否向老师展示报告
                menus: [], // 自定义配置菜单栏
                studentMenus: [], // 自定义学生pc端菜单栏
                scaleAlias: false, // 量表显示别名  （屏蔽"心理"字段）
                realmName: 'https://gljy.lanyunxinli.cn' // 域名地址
            },

        ]
    },
    mutations: {
        // 通过域名地址获取教育局配置信息
        getEduWebConfigInfo(state) {

            let currentHref = window.location.href.split('lanyunxinli.cn'); // 获取当前网页地址
            if (currentHref[0].indexOf('http://localhost') == -1) {
                currentHref = currentHref[0] + 'lanyunxinli.cn'; // 获取当前域名
            } else {
                currentHref = "https://www.lanyunxinli.cn"
            }
            let currentEdu = state.eudList.find(e => e.realmName == currentHref); // 通过域名获取
            if (currentEdu) {
                LYCom.CallBizCfg.QrcodeUrl = currentEdu.realmName + '/mobile/';
                document.title = currentEdu.eduName + currentEdu.webName;
                state.eduWebConfigInfo = currentEdu;
            }
        },
        // 更新学习信息弹框展示状态
        updateStudentBasicInfoDialog(state, bool) {
            state.studentInfoDialog = bool
        }

    },
}

export default eduWebConfig



// WEBPACK FOOTER //
// ./src/store/modules/eduwebconfig.js